export default () => ({
  sourceTypeList: [],
});
